import React from "react"
import { Notification } from "@nova/schemas"
import { isNotifiableEventKind } from "@nova/notifications"
import { useNotificationContext } from "./notificationContext"
import { buildWebCopy, WebNotificationCopy } from "./webCopy"
import { notificationComponentByKind } from "./kinds/registry"

export const NotificationCard = ({ notification }: { notification: Notification }) => {
    const context = useNotificationContext(notification)
    const copy = buildWebCopy(notification, context)

    if (!copy || !isNotifiableEventKind(notification.kind)) return null

    const KindComponent = notificationComponentByKind[notification.kind] as (props: {
        notification: Notification
        copy: WebNotificationCopy
        actorName: string | undefined
    }) => React.ReactNode

    return <KindComponent notification={notification} copy={copy} actorName={context.actorName} />
}
